import React from 'react';
import About from './components/about'
import HomePage from './components/home'
import Forms from './components/forms'

import { Routes, Route } from "react-router-dom";
import Layout from './components/layout'

function App() {
  return (
    <div className="App">
    <Routes>
      <Route path='/' element={<Layout />}>
        <Route index element={<HomePage />}/>
        <Route path="/about" element={<About/>}/>
        <Route path='/forms' element={<Forms />}/>
      </Route>
    </Routes>
    </div>
  );
}

export default App;
